import { ScanAtCheckoutScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ScanAtCheckoutScreen />;
}
